<template>
  <div class="mod-config">
    <div class="masklayer" v-show="masklayer"></div>
    <div class="approval" v-if="show">
    <div class="title">
      <div class="title1">催促表</div>
      <div class="exit" @click="exit">退出</div>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%"
      height="150">
      <el-table-column
        prop="name"
        align="center"
        label="公司名"
        width="200">
      </el-table-column>
      <el-table-column
        prop="code"
        align="center"
        label="信用码"
        width="200">
      </el-table-column>
      <el-table-column
        prop="status"
        align="center"
        label="操作"
        width="200">
        <template slot-scope="scope">
          <el-button
          size="mini"
          @click=" approval(scope.row)">确定</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
    <el-form
      :inline="true"
      :model="dataForm"
      @keyup.enter.native="getDataList()"
    >
      <!-- <el-form-item>
                <el-select
                    v-model="dataForm.industryCode"
                    filterable
                    placeholder="行业"
                    clearable
                >
                    <el-option
                        v-for="item in industryList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item> -->
      <!-- <el-form-item>
                <el-select
                    v-model="dataForm.areaCode"
                    filterable
                    placeholder="区域"
                    clearable
                >
                    <el-option
                        v-for="item in areaList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item> -->
      <el-form-item>
        <el-input
          v-model="dataForm.enterpriseName"
          placeholder="请输入企业名称"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getDataList(1)">查询</el-button>
        <el-button
          v-if="isAuth('enterprise/enterprise/save')"
          @click="addOrUpdateHandle()"
          >新增
        </el-button>
        <el-button
          v-if="isAuth('enterprise/enterprise/delete')"
          type="danger"
          @click="deleteHandle()"
          :disabled="dataListSelections.length <= 0"
          >批量删除
        </el-button>
          <el-button type="warning" @click="chongzhi">重置 </el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="dataList"
      border
      v-loading="dataListLoading"
      @selection-change="selectionChangeHandle"
      style="width: 100%"
    >
      <el-table-column type="index" width="50" label="#" align="center"> </el-table-column>
      <el-table-column
        type="selection"
        header-align="center"
        align="center"
        width="50"
      >
      </el-table-column>
      <el-table-column
        prop="enterpriseName"
        header-align="center"
        align="center"
        label="企业名称"
        width="200"
        show-overflow-tooltip
      >
       <template slot-scope="scope">
          <span  @click="showProduct(scope.row.introduction)" style="color:#409eff; cursor: pointer;">{{ scope.row.enterpriseName }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="businessLicenseNumber"
        header-align="center"
        align="center"
        label="工商注册码"
      >
      </el-table-column> -->
      <el-table-column
        prop="enterpriseCode"
        header-align="center"
        align="center"
        label="社会信用码"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
          prop="scale"
          header-align="center"
          align="center"
          label="企业规模"
      >
      </el-table-column>
            <!-- <el-table-column
                prop="areaName"
                header-align="center"
                align="center"
                label="所属区域"
            >
            </el-table-column>  -->
      <!-- <el-table-column
        prop="enterpriseType"
        header-align="center"
        align="center"
        label="企业类型"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.enterpriseType === 0" size="small"
            >国企</el-tag
          >
          <el-tag
            v-if="scope.row.enterpriseType === 1"
            size="small"
            type="success"
            >民企</el-tag
          >
          <el-tag v-if="scope.row.enterpriseType === 2" size="small" type="info"
            >私企</el-tag
          >
          <el-tag v-if="scope.row.enterpriseType === 3" size="small"
            >外企</el-tag
          >
        </template>
      </el-table-column> -->
      <!-- <el-table-column
        prop="telephone"
        header-align="center"
        align="center"
        label="企业联系电话"
      >
      </el-table-column> -->
      <!-- <el-table-column
        prop="email"
        header-align="center"
        align="center"
        label="企业邮箱"
      >
      </el-table-column>
      <el-table-column
        prop="zipCode"
        header-align="center"
        align="center"
        label="邮政编码"
      >
      </el-table-column> -->
      <!-- <el-table-column
        prop="corporate"
        header-align="center"
        align="center"
        label="法人模板"
      >
      </el-table-column> -->
      <!-- <el-table-column
        prop="legalPerson"
        header-align="center"
        align="center"
        label="法人"
      >
      </el-table-column> -->
      <!-- <el-table-column
        prop="mainPerson"
        header-align="center"
        align="center"
        label="企业负责人姓名"
      >
      </el-table-column> -->
      <!-- <el-table-column
        prop="website"
        label="企业网站"
        width="150"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="mainPersonMobile"
        header-align="center"
        align="center"
        label="企业负责人电话"
      >
      </el-table-column> -->
      <el-table-column prop="logo" label="logo" align="center" width="130">
        <template slot-scope="scope">
          <div class="img-show">
            <el-image
              v-if="scope.row.logo != null"
              width="75%"
              contain
              class="image-slot"
              :src="scope.row.logo"
              :preview-src-list="[scope.row.logo]"
              fit="contain"
            ></el-image>
            <div v-else slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="businessLicense"
        label="营业执照"
        align="center"
        width="130"
      >
        <template slot-scope="scope">
          <div class="img-show">
            <el-image
              v-if="scope.row.businessLicense != null"
              width="75%"
              contain
              class="image-slot"
              :src="scope.row.businessLicense"
              :preview-src-list="[scope.row.businessLicense]"
              fit="contain"
            ></el-image>
            <div v-else slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="commitment"
        label="承诺书"
        align="center"
        width="130"
      >
        <template slot-scope="scope">
          <div class="img-show">
            <el-image
              v-if="scope.row.commitment != null"
              width="75%"
              contain
              class="image-slot"
              :src="scope.row.commitment"
              :preview-src-list="[scope.row.commitment]"
              fit="contain"
            ></el-image>
            <div v-else slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center" width="100">
        <template slot-scope="scope">
          <el-button
            size="mini"
            plain
            class="padding-style"
            :type="scope.row.status == 0 ? 'success' : 'danger'"
            @click="changeShow(scope.row)"
          >
            {{ scope.row.status == 0 ? "显示" : "不显示" }}
          </el-button>
        </template>
      </el-table-column>
      <!-- <el-table-column label="内容" align="center" width="120">
        <template slot-scope="scope">
          <el-popover placement="right" width="400" trigger="click">
            <span v-html="showcontent(scope.row.introduction)"></span>
            <el-button slot="reference">内容详情</el-button>
          </el-popover>
        </template>
      </el-table-column> -->
      <!-- <el-table-column label="详情展示" align="center" width="100">
        <template slot-scope="scope">
          <el-popover placement="right" width="400" trigger="click">
            <el-form
              label-position="left"
              inline
              class="demo-table-expand"
              label-width="100px"
            >
              <el-form-item label="企业网站">
                <span v-html="showcontent(scope.row.website)"></span>
              </el-form-item>
              <el-form-item label="工商注册码">
                <span>{{ scope.row.businessLicenseNumber }}</span>
              </el-form-item>
              <el-form-item label="企业编号">
                <span>{{ scope.row.enterpriseCode }}</span>
              </el-form-item>
              <el-form-item label="企业联系人电话">
                <span>{{ scope.row.telephone }}</span>
              </el-form-item>
              <el-form-item label="企业负责人电话">
                <span>{{ scope.row.mainPersonMobile }}</span>
              </el-form-item>
               <el-form-item label="城市编码">
                <span>{{ scope.row.cityCode }}</span>
              </el-form-item>
              <el-form-item label="地址">
                <span>{{ scope.row.address }}</span>
              </el-form-item>
              <el-form-item label="邮政编码">
                <span>{{ scope.row.zipCode }}</span>
              </el-form-item>
              <el-form-item label="邮箱">
                <span>{{ scope.row.email }}</span>
              </el-form-item>
              <el-form-item label="法人">
                <span>{{ scope.row.legalPerson }}</span>
              </el-form-item>
              <el-form-item label="企业负责人" >
                <span>{{ scope.row.mainPerson }}</span>
              </el-form-item>
            </el-form> -->

            <!-- <el-link class="overflow" :underline="false" slot="reference"> -->
            <!-- <el-button slot="reference">详情展示</el-button> -->
            <!-- </el-link> -->
          <!-- </el-popover>
        </template>
      </el-table-column> -->
      <!-- <el-table-column
                prop="mapX"
                header-align="center"
                align="center"
                label="x坐标"
            >
            </el-table-column>
            <el-table-column
                prop="mapY"
                header-align="center"
                align="center"
                label="y坐标"
            >
            </el-table-column>
            <el-table-column
                prop="mapZ"
                header-align="center"
                align="center"
                label="z坐标"
            >
            </el-table-column> -->
      <!-- <el-table-column
        prop="address"
        header-align="center"
        align="center"
        label="地址"
      >
      </el-table-column> -->
      <!-- <el-table-column
                prop="status"
                header-align="center"
                align="center"
                label="企业状态"
            >
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.status === 0" size="small"
                        >正常</el-tag
                    >
                    <el-tag
                        v-if="scope.row.status === 1"
                        size="small"
                        type="danger"
                        >禁用</el-tag
                    >
                </template>
            </el-table-column> -->
      <!-- <el-table-column
        prop="createTime"
        header-align="center"
        align="center"
        label="创建时间"
      >
      </el-table-column>
      <el-table-column
        prop="updateTime"
        header-align="center"
        align="center"
        label="更新时间"
      >
      </el-table-column> -->
      <el-table-column
        fixed="right"
        header-align="center"
        align="center"
        width="150"
        label="操作"
      >
        <template slot-scope="scope">
          <el-button
            v-if="isAuth('enterprise/enterprise/update')"
            type="text"
            size="small"
            @click="addOrUpdateHandle(scope.row.id)"
            >修改
          </el-button>
          <el-button
            v-if="isAuth('enterprise/enterprise/delete')"
            type="text"
            size="small"
            @click="deleteHandle(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total,prev, pager, next"
    >
    </el-pagination>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update
      v-if="addOrUpdateVisible"
      ref="addOrUpdate"
      @refreshDataList="getDataList"
    ></add-or-update>
     <!-- 商品内容详情 -->
      <el-dialog
          title="企业介绍"
          :visible.sync="dialogVisible"
          width="50%"
          custom-class="product-dialog"
      >
          <div v-html="showcontent(content)"></div>
      </el-dialog>
  </div>
</template>

<script>
import AddOrUpdate from "./enterprise-add-or-update";

import { showcontent } from "@/utils/method.js";
export default {
  data() {
    return {
      masklayer:true,
      dialogVisible:false,
      content:'',
      show:true,
      tableData: [],
      dataForm: {
        industryCode: "",
        areaCode: "",
        cityCode: "",
        enterpriseName: "",
        corporate: "",
        // status:''
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false,
      industryList: [],
      areaList: [],
      logo: [],
    };
  },
  components: {
    AddOrUpdate,
  },
  activated() {
    this.getDataList();
    this.initIndustryList();
    this.initAreaList();
    this.init()
  },
  methods: {
    chongzhi(){
      this.dataForm.enterpriseName = '' 
      this.$nextTick(() =>{
        this.getDataList()
      })
    },
    exit(){
      this.show = false
      this.masklayer = false
    },
    // 审批
    approval(row) {
      console.log(row);
      this.$http({
        url:this.$http.adornUrl('/update/urge/open'),
        method:'post',
        data:this.$http.adornData({
          enterpriseName:row.name,
          code:row.code,
          status:0
        })
        }).then(res=>{
          if(res.data.code != 0) {
            this.$message({
              title:'错误',
              type:'error',
              message:res.data.msg
            })
          }else{
            this.$message({
              title:'成功',
              type:'success',
              message:'已查看,请审核'
            })
            this.exit()
            // this.init
          }
      })
    },
    // 获取催处信息
    init() {
      this.$http({
        url:this.$http.adornUrl('/find/urge/open'),
        method:'get',
      }).then(res=>{
        res.data.data.forEach(element => {
           const data = {}
           data.name = element.enterpriseName
           data.code = element.code
           this.tableData.push(data)
        });
        if (this.tableData.length == 0) {
          this.exit()
        }
      })
    },
    showProduct(content) {
        this.content = content;
        this.dialogVisible = true;
    },
    showcontent,
    // 获取数据列表
    getDataList(a) {
      a ? this.pageIndex = a : this.pageIndex
      this.dataListLoading = true;
      this.$http({
        url: this.$http.adornUrl("/enterprise/getList"),
        method: "post",
        data: this.$http.adornData({
          page: this.pageIndex,
          limit: this.pageSize,
          industryCode: this.dataForm.industryCode,
          areaCode: this.dataForm.areaCode,
          enterpriseName: this.dataForm.enterpriseName,
          cityCode: this.dataForm.cityCode,
          corporate: this.dataForm.corporate,
        }),
      }).then(({ data }) => {
        console.log("企业信息列表", data);
        if (data && data.code === 0) {
          console.log(data.data.list);
          this.dataList = data.data.list;
          this.totalPage = data.data.totalCount;
          // console.log(data.data.logo);
          // this.logo.push()
        } else {
          this.dataList = [];
          this.totalPage = 0;
        }
        this.dataListLoading = false;
      });
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val;
    },
    // 新增 / 修改
    addOrUpdateHandle(id) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id);
      });
    },
    // 点击显示/不显示按钮
    changeShow(item) {
      let { id, status } = item;
      status = status === 1 ? 1 : 0;
      this.$ajaxGet("/enterprise/status", {
        id: parseInt(id),
      }).then(({ data }) => {
        if (data.code === 0) {
          this.getDataList();
        }
      });
    },
    // 删除
    deleteHandle(id) {
      var ids = id
        ? [id]
        : this.dataListSelections.map((item) => {
            return item.id;
          });
      this.$confirm(
        `确定对[id=${ids.join(",")}]进行[${id ? "删除" : "批量删除"}]操作?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        this.$http({
          url: this.$http.adornUrl("/enterprise/delete"),
          method: "post",
          data: this.$http.adornData(ids, false),
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.$message({
              message: "操作成功",
              type: "success",
              duration: 1500,
              onClose: () => {
                this.getDataList();
              },
            });
          } else {
            this.$message.error(data.msg);
          }
        });
      });
    },
    initIndustryList() {
      this.industryList = [];
      this.$http({
        url: this.$http.adornUrl("/sys/dic/select/9"),
        method: "get",
        params: this.$http.adornParams(),
      }).then(({ data }) => {
        this.industryList = data.data;
      });
    },
    initAreaList() {
      this.areaList = [];
      this.$http({
        url: this.$http.adornUrl("/sys/dic/select/16"),
        method: "get",
        params: this.$http.adornParams(),
      }).then(({ data }) => {
        this.areaList = data.data;
      });
    },
  },
};
</script>
<style lang="less" scoped>
  /deep/.el-icon-circle-close{
  color:white
}
.masklayer{
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 20;
      background-color: rgba(189, 187, 187, 0.5);
  }
.approval{
  position: absolute;
  z-index: 999;
  top:25%;
  left: 25%;
  .title{
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    padding: 20px 30px;
    background-color: #fafafa;
    .exit{
      color: blue;
      cursor: pointer;
    }
  }
}
</style>